import {
  COUNTERPARTY,
  COUNTERPARTY_INVITATION,
  USER_INVITATION_COUNTERPARTY,
  CONTRACT,
  CONTRACT_INVITATION,
  CONTRACT_CUSTOMER_STORAGE,
  CONTRACT_STORAGE,
  CONTRACT_DATABASE,
  USER_INVITATION_CONTRACT,
  CONTRACT_CUSTOMER_DATABASE,
  CONTRACT_CERTIFICATE,
  CONTRACT_SITE,
  CONTRACT_DOMAIN,
  CONTRACT_DOMAIN_RECORD,
  CONTRACT_CRON,
  CONTRACT_BACKUP_DATABASE,
  CONTRACT_BACKUP_STORAGE,
  STORAGE_FILE_MANAGER,
  CONTRACT_QUICK_MAKE_SITE,
  FRONTEND_UPDATE
} from "~/constants/broadcast/modifiedData";

export const reloadData = {
  [COUNTERPARTY]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["counterparty.index"],
        fetchData: ["counterparty/fetchCounterparties"]
      }
    ]
  },
  [COUNTERPARTY_INVITATION]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["counterparty.index"],
        fetchData: ["counterparty/fetchCounterparties"]
      }
    ]
  },
  [USER_INVITATION_COUNTERPARTY]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["invitation.counterparties"],
        fetchData: [
          {
            action:
              "userInvitationCounterparty/fetchUserInvitationCounterparties",
            paramsKey: "userId"
          }
        ]
      }
    ]
  },
  [CONTRACT_STORAGE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.storage.index"],
        fetchData: [
          "contractStorage/fetchContractStorages",
          "contractStorage/fetchStoragesMetrics"
        ]
      },
      {
        routeName: ["contract.cabinet.site.index"],
        fetchData: ["contractSite/fetchContractSites"]
      },
      {
        routeName: ["contract.cabinet.customers.index"],
        fetchData: ["contractCustomer/fetchContractCustomers"]
      },
      {
        routeName: ["contract.cabinet.backups.storage.index"],
        fetchData: ["contractBackupStorage/fetchContractBackupStorage"]
      }
    ]
  },
  [CONTRACT]: {
    alwaysFetch: ["user/fetchBroadcast", "contract/fetchJoinedContracts"],
    conditionalFetch: [
      {
        routeName: ["contract.index"],
        fetchData: ["contract/fetchContracts"]
      },
      {
        routeName: ["contract.index"],
        fetchData: ["contract/fetchContractsBalance"]
      }
    ]
  },
  [CONTRACT_INVITATION]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.history.index"],
        fetchData: ["contractHistory/fetchContractHistories"]
      }
    ]
  },
  [USER_INVITATION_CONTRACT]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["invitation.contracts"],
        fetchData: ["userInvitationContract/fetchUserInvitationContract"]
      }
    ]
  },
  [CONTRACT_CUSTOMER_DATABASE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.customers.db.index", "contract.cabinet.database.edit"],
        fetchData: [
          "contractCustomerDatabase/fetchCustomers",
          "contractDatabase/fetchDatabasesMetrics"
        ]
      },
    ]
  },
  [CONTRACT_CUSTOMER_STORAGE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.customers.index"],
        fetchData: ["contractCustomer/fetchContractCustomers"]
      }
    ]
  },
  [CONTRACT_DATABASE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.database.index"],
        fetchData: [
          "contractDatabase/fetchContractDatabases",
          "contractDatabase/fetchDatabasesMetrics"
        ]
      },
      {
        routeName: ["contract.cabinet.site.index"],
        fetchData: ["contractSite/fetchContractSites"]
      },
      {
        routeName: ["contract.cabinet.customers.db.index"],
        fetchData: ["contractCustomerDatabase/fetchCustomers"]
      },
      {
        routeName: ["contract.cabinet.backups.database.index"],
        fetchData: ["contractBackupDatabase/fetchContractBackupDatabase"]
      }
    ]
  },
  [CONTRACT_CERTIFICATE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.certificate.index"],
        fetchData: ["contractCertificate/fetchContractCertificates"]
      },
      {
        routeName: ["contract.cabinet.site.index"],
        fetchData: ["contractSite/fetchContractSites"]
      },
      {
        routeName: ["contract.cabinet.domain.index"],
        fetchData: ["contractDomain/fetchContractDomains"]
      }
    ]
  },
  [CONTRACT_SITE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.site.index"],
        fetchData: ["contractSite/fetchContractSites"]
      },
      {
        routeName: ["contract.cabinet.storage.index"],
        fetchData: ["contractStorage/fetchContractStorages"]
      },
      {
        routeName: ["contract.cabinet.database.index"],
        fetchData: ["contractDatabase/fetchContractDatabases"]
      },
      {
        routeName: ["contract.cabinet.certificate.index"],
        fetchData: ["contractCertificate/fetchContractCertificates"]
      },
      {
        routeName: ["contract.cabinet.domain.index"],
        fetchData: ["contractDomain/fetchContractDomains"]
      }
    ]
  },
  [CONTRACT_BACKUP_DATABASE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.backups.database.index"],
        fetchData: ["contractBackupDatabase/fetchContractBackupDatabase"]
      },
      {
        routeName: ["contract.cabinet.backup.database.plan.index"],
        fetchData: ["contractBackupDatabasePlan/fetchContractBackupDatabasePlans"]
      }
    ]
  },
  [CONTRACT_BACKUP_STORAGE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.backups.storage.index"],
        fetchData: ["contractBackupStorage/fetchContractBackupStorage"]
      },
      {
        routeName: ["contract.cabinet.backup.storage.plan.index"],
        fetchData: ["contractBackupStoragePlan/fetchContractBackupStoragePlans"]
      }
    ]
  },
  [CONTRACT_DOMAIN]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.domain.index"],
        fetchData: ["contractDomain/fetchContractDomains"]
      },
      {
        routeName: ["contract.cabinet.site.index"],
        fetchData: ["contractSite/fetchContractSites"]
      },
      {
        routeName: ["contract.cabinet.certificate.index"],
        fetchData: ["contractCertificate/fetchContractCertificates"]
      }
    ]
  },
  [CONTRACT_DOMAIN_RECORD]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.domains.records.index"],
        fetchData: [
          {
            action: "contractDomainRecord/fetchContractDomainRecords",
            paramsKey: "domainId"
          }
        ]
      },
      {
        routeName: ["contract.cabinet.domain.index"],
        fetchData: ["contractDomain/fetchContractDomains"]
      }
    ]
  },
  [CONTRACT_CRON]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.crons.index"],
        fetchData: ["contractCron/fetchContractCrons"]
      },
      {
        routeName: ["contract.cabinet.site.index"],
        fetchData: ["contractSite/fetchContractSites"]
      }
    ]
  },
  [STORAGE_FILE_MANAGER]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.storageManager.index", "storageManager.index"],
        fetchData: ["contractCustomerStorage/fetchCustomers"]
      }
    ]
  },
  [CONTRACT_QUICK_MAKE_SITE]: {
    alwaysFetch: ["user/fetchBroadcast"],
    conditionalFetch: [
      {
        routeName: ["contract.cabinet.index"],
        fetchData: ["siteQuickMode/fetchSiteQuickModes"]
      }
    ]
  },
  [FRONTEND_UPDATE]: {
    alwaysFetch: ["frontendUpdate/triggerReloadNotice"],
    conditionalFetch: []
  }
};
